// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"90":"af9b0653","284":"c35a2f39","422":"702ae7e4","432":"efddc85d","688":"1b9c568e","869":"3be19dcb","965":"258ead74"}[chunkId] + ".chunk.js";
};